import React, { createContext, useState, useEffect } from "react";
import APICall from "./utils/APICalls";

export const UserContext = createContext(null);

export const UserProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const fetchUser = async () => {
    try {
      const response = await APICall.get("User/Me");
      if (response && response.succeeded && response.object) {
        setUser(response.object);
      } else {
        setUser(null);
      }
    } catch (error) {
      setUser(null);
    } finally {
      setLoading(false);
    }
  };

  const login = async (userData) => {
    setLoading(true);
    await fetchUser();
  };

  const logout = () => {
    setUser(null);
  };

  const clearUser = () => {
    setUser(null);
  };

  useEffect(() => {
    // Register clearUser callback with APICalls
    const { setClearUserCallback } = require("./utils/APICalls");
    setClearUserCallback(clearUser);

    fetchUser();
  }, []);

  const EXTERNAL_ROLES = ["{BRDADM}", "{BRDMEM}", "{BRDOBS}", "{GUEST}"];
  const isExternal =
    user != null && EXTERNAL_ROLES.some((r) => user?.roles?.includes(r));

  return (
    <UserContext.Provider
      value={{
        user,
        loading,
        login,
        logout,
        refetchUser: fetchUser,
        clearUser,
        isExternal,
      }}
    >
      {children}
    </UserContext.Provider>
  );
};
